import React from 'react';
import { SectorPageTemplate } from '../components/SectorPageTemplate';
export function SectorMakelaarsVastgoedPage() {
  return <SectorPageTemplate sectorName="Makelaars & Vastgoed" sectorSlug="makelaars-vastgoed" heroTitle="Webdesign voor makelaars en vastgoedbedrijven" heroDescription="Professionele websites voor makelaars, projectontwikkelaars en vastgoedbeheerders. Wij bouwen websites die woningen presenteren en leads genereren." whyTitle="Waarom een goede website essentieel is in vastgoed" whyDescription="De huizenmarkt is competitief. Een premium online uitstraling trekt zowel kopers als verkopers aan." whyItems={[{
    icon: 'HomeIcon',
    title: 'Woningen presenteren',
    description: 'Een overzichtelijk en visueel aantrekkelijk woningaanbod houdt bezoekers langer op je site.'
  }, {
    icon: 'UsersIcon',
    title: 'Leads genereren',
    description: 'Zet websitebezoekers om in concrete aanvragen voor bezichtigingen en waardebepalingen.'
  }, {
    icon: 'SearchIcon',
    title: 'Lokaal vindbaar',
    description: 'Word gevonden door mensen die een huis willen kopen of verkopen in jouw regio.'
  }, {
    icon: 'ShieldCheckIcon',
    title: 'Betrouwbaar overkomen',
    description: 'Een strakke, moderne website straalt de professionaliteit uit die past bij grote transacties.'
  }]} features={[{
    icon: 'SearchIcon',
    title: 'Woningoverzicht & filters',
    description: 'Laat bezoekers eenvoudig zoeken op prijs, locatie, type woning en andere kenmerken.'
  }, {
    icon: 'CalendarCheckIcon',
    title: 'Bezichtiging aanvragen',
    description: 'Geïntegreerde formulieren waarmee geïnteresseerden direct een bezichtiging kunnen plannen.'
  }, {
    icon: 'LaptopIcon',
    title: 'CRM-koppeling',
    description: 'Koppel je website aan systemen zoals Realworks of Kolibri voor automatisch woningaanbod.'
  }]} clusters={[{
    name: 'Makelaar',
    slug: 'makelaar',
    label: 'Makelaardij',
    description: 'Websites voor aankoop- en verkoopmakelaars met woningaanbod.'
  }, {
    name: 'Projectontwikkelaar',
    slug: 'projectontwikkelaar',
    label: 'Nieuwbouw',
    description: 'Websites voor nieuwbouwprojecten en projectontwikkelaars.'
  }, {
    name: 'Vastgoedbeheer',
    slug: 'vastgoedbeheer',
    label: 'Beheer',
    description: 'Websites voor vastgoedbeheerders en verhuurders.'
  }, {
    name: 'Woningpresentatie',
    slug: 'woningpresentatie',
    label: 'Presentatie',
    description: 'Websites voor vastgoedfotografen en stylisten.'
  }]} faqs={[{
    q: 'Wat kost een website voor een makelaar?',
    a: 'Een basis website start rond de €1.500. Voor een website met een automatische koppeling naar je CRM (zoals Realworks) voor het woningaanbod maken we een offerte op maat.'
  }, {
    q: 'Kunnen jullie mijn website koppelen aan Funda?',
    a: 'Ja, we kunnen je website koppelen aan je makelaars-CRM, waardoor woningen die je daar invoert automatisch op je website (en Funda) verschijnen.'
  }, {
    q: 'Hoe zorg ik voor meer aanvragen voor waardebepalingen?',
    a: "We richten de website conversiegericht in met duidelijke call-to-actions en speciale landingspagina's voor gratis waardebepalingen."
  }, {
    q: 'Is de website goed zichtbaar op mobiel?',
    a: 'Zeker. Meer dan 60% van de huizenzoekers gebruikt een mobiele telefoon. Onze websites zijn volledig responsive en werken perfect op elk schermformaat.'
  }]} relatedPages={[{
    name: 'Website laten maken',
    href: '#/website-laten-maken'
  }, {
    name: 'SEO voor websites',
    href: '#/seo-voor-websites'
  }]} data-id="element-1681" />;
}